import { StorefrontSection } from '../../redux-toolkits/shared/shared.type'

export const DEFAULT_CATEGORY_SECTION: StorefrontSection = 'LIFESTYLE'

export const categorySectionOptions: {
  text: string
  value: StorefrontSection
}[] = [
  { text: 'Lifestyle', value: 'LIFESTYLE' },
  { text: 'Food', value: 'FOOD' },
  { text: 'Events', value: 'EVENT' },
]

export const getCategorySectionLabel = (section?: StorefrontSection) =>
  categorySectionOptions.find(
    ({ value }) => value === (section ?? DEFAULT_CATEGORY_SECTION),
  )?.text
